export default __webpack_public_path__ + "static/media/f_partial.366650d2.svg";